<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-08-04 19:26:08
 * @LastEditors: sjq
 * @LastEditTime: 2024-05-23 15:15:49
 -->
<template>
  <div class="minheight100" v-if="detail">
    <app-header v-if="appUser.isNative" title="友邻少年"></app-header>
    <div class="share-activity-submit" ref="activityMain">
      <div class="apply-status">
        <template v-if="examineData.examineStatus === 0">
          <div class="status status1">
            <img src="./images/status_icon1.png" alt="" />
            提交成功
          </div>
          <div class="commit">预计将在3个工作日内出审核结果，请您耐心等待</div>
        </template>
        <template v-else-if="examineData.examineStatus === 1">
          <div class="status status2">
            <img src="./images/status_icon2.png" alt="" />
            {{ dataDetail.receiveType === 2 ? '领取成功' : '审核通过' }}
          </div>
          <div class="commit" v-if="detail.type === '20001'">
            {{
              appUser.isNative
                ? '该课程已发放至您的账户，请前往书桌查看'
                : '该课程已发发放至您的账户，请前往App进行查看'
            }}
          </div>
          <template v-else-if="detail.type === '60001'">
            <div class="commit" v-if="appUser.isNative">奖品已发放至您的账户，可立即使用</div>
            <template v-else>
              <div class="commit">该奖品已发发放至您的账户</div>
              <div class="commit">
                请前往{{ appUser.isNative ? '' : 'App' }}
                <span style="color: #ff7142">【我的】-【卡券】</span>
                中使用
              </div>
            </template>
          </template>
          <template v-else-if="detail.type === 'credit'">
            <div class="commit">
              {{
                appUser.isNative
                  ? '积分已发放到您的账户，请前往积分商城使用'
                  : '积分已发放至您的账户，请前往App进行查看'
              }}
            </div>
          </template>
          <template v-else-if="detail.type === '10010'">
            <div class="commit">{{ appUser.isNative ? '' : '长按' }}扫码添加老师微信领取奖品</div>
          </template>
          <template v-else-if="detail.type === '90001'">
            <div class="commit" v-if="examineData.expressSn">快递已发出，请及时关注物流信息</div>
            <div v-else>
              奖品会在
              <span style="color: #ff7142">30个工作日</span>
              内发货，感谢您耐心等待
            </div>
          </template>
        </template>
        <template v-else-if="examineData.examineStatus === 2">
          <div class="status status3">
            <img src="./images/status_icon3.png" alt="" />
            审核失败
          </div>
          <div class="commit" ref="errorMessage" @click="errorShow = true">
            {{ errorMessage.slice(0, errorShowNum) }}
            <span v-if="isErrorIcon">
              ...
              <Icon name="arrow" />
            </span>
          </div>
          <div class="status-btn">
            <div class="btn-common block" @click="afresh">重新上传审核信息</div>
          </div>
        </template>
      </div>
      <div class="gz-gzh" v-if="detail.type === '90001' && examineData.examineStatus === 1 && !examineData.expressSn">
        <div class="gz-content">
          <div class="gz-title">
            关注
            <span>[友邻少年]</span>
            公众号
          </div>
          <div class="gz-commit">发货后，将第一时间通知你</div>
        </div>
        <div class="gz-btn btn-common block" @click="gzhShow = true">关注</div>
      </div>
      <div class="prize-main">
        <div class="prize-img prize-img1" v-if="detail.type === 'credit'">
          <div class="card-con">
            <div class="text">
              {{ detail.num }}
            </div>
          </div>
          <div class="zd">
            {{ detail.goodsName }}
          </div>
        </div>
        <!-- 0 90001实物  1 credit积分  2 20001专辑   4 60001礼品卡 5 10010自定义 -->
        <div
          class="prize-img"
          :class="{ 'prize-img2': detail.type === '20001', 'prize-img4': detail.type === '60001' }"
          v-else
        >
          <img v-if="detail.type === '60001'" :src="detail.giftCardImg" alt="" />
          <template v-else-if="detail.type === '90001'">
            <img :src="detail.realGoodsImg" v-if="detail.realGoodsImg" />
            <img src="./images/good_default.png" alt="" v-else />
          </template>
          <img v-else-if="detail.type === '10010'" :src="detail.realGoodsImg" alt="" />
          <img v-else-if="detail.type === '20001'" :src="detail.albumCover" alt="" />
        </div>
        <div class="prize-detail">
          <div class="prize-title">{{ detail.type === 'credit' ? detail.num : '' }} {{ detail.goodsName }}</div>
          <div class="prize-commit" v-if="detail.type === '60001'">
            {{
              detail.termType == 1
                ? detail.useStartDate.split('T')[0].replace(/-/g, '.') +
                  '-' +
                  detail.useEndDate.split('T')[0].replace(/-/g, '.') +
                  '有效'
                : '领取后' + detail.dayUse + '天内有效'
            }}
          </div>
          <div class="prize-commit" v-else-if="detail.type === '20001'">{{ detail.albumDescription }}</div>
          <div class="prize-commit" v-else-if="detail.type === '10010'">{{ detail.goodsDescription }}</div>
          <template v-if="detail.type === '20001'">
            <div class="num">共 {{ detail.courseCount }} 节</div>
            <div class="day">{{ detail.equityDays }} 天内有效</div>
          </template>
        </div>
      </div>
      <div class="adviser-img" v-if="detail.type === '10010' && examineData.examineStatus !== 0">
        <div class="border"></div>
        <img v-if="dataDetail" :src="dataDetail.adviserErCode" alt="" />
        <div v-if="appUser.isNative" class="commit">截图后，前往微信扫一扫</div>
      </div>
      <div class="address-box" v-if="detail.type === '90001'" @click="setAddress">
        <div class="address-main">
          <div class="address-icon">
            <img src="./images/address_icon.png" alt="" />
          </div>
          <div class="address-content" v-if="addressDetail">
            <div class="address-detail">
              <div class="name">
                {{ addressDetail.contactName }}
              </div>
              <div class="contact">
                {{ addressDetail.contactNo }}
              </div>
            </div>
            <div class="address-commit">
              {{ addressDetail.addressArea.split(' / ').join('') }}{{ addressDetail.addressDetail }}
            </div>
          </div>
          <Icon name="arrow" v-if="examineData.examineStatus === 0" />
          <!-- <div class="address-content" v-else>
          <div class="div address-content-tip">
            添加收货地址
          </div>
        </div> -->
        </div>
        <template v-if="examineData.expressSn">
          <div class="express-detail">
            <div class="express-box">
              <div class="img">
                <img src="./images/express-icon.svg" alt="" />
              </div>
              {{ examineData.expressCompany }}
              {{ examineData.expressSn }}
            </div>
            <div class="copy" @click="copy(examineData.expressSn, $event)">复制</div>
          </div>
          <Steps class="express-info" direction="vertical" :active="0" active-color="#FF7142">
            <Step v-for="(item, index) in wlList" :key="index">
              <p>{{ item.ftime }}</p>
              <div>{{ item.context }}</div>
            </Step>
          </Steps>
        </template>
      </div>
      <div class="go-app-btn" v-if="examineData.examineStatus === 1 && ['90001', '10010'].indexOf(detail.type) === -1">
        <div class="btn-common block" @click="goApp">
          {{
            appUser.isNative
              ? detail.type === '60001' || detail.type === 'credit'
                ? '去使用'
                : detail.type === '60001'
                ? '开始使用'
                : '立即查看'
              : '前往App查看'
          }}
        </div>
      </div>
    </div>
    <div class="fixed-bottom" :style="isFixedBottom ? '' : { position: 'relative' }">
      <span class="" @click="show = true">
        <Icon name="service-o" />
        联系客服
      </span>
    </div>
    <div class="activity-home" v-if="!appUser.isNative && dataDetail && dataDetail.shareActivityId" @click="goActivity">
      活动主页
    </div>
    <Popup v-model="show" position="bottom" round>
      <div class="service-popup">
        <Icon name="cross" class="close-icon" @click="show = false" />
        <div class="title">联系客服</div>
        <div class="tip">
          {{ appUser.isNative ? '截图后，打开微信“扫一扫”识别二维码' : '长按识别二维码，添加微信' }}
        </div>
        <div class="img">
          <img v-if="dataDetail" :src="dataDetail.adviserErCode" alt="" />
        </div>
      </div>
    </Popup>
    <Popup v-model="gzhShow" position="bottom" round>
      <div class="service-popup">
        <Icon name="cross" class="close-icon" @click="gzhShow = false" />
        <div class="title">关注友邻少年，接收发货提醒</div>
        <div class="tip">
          {{ appUser.isNative ? '长按保存后，打开微信识别二维码' : '长按识别二维码' }}
        </div>
        <div class="img">
          <img v-if="dataDetail" src="./images/activity_gzh_qr.png" alt="" />
        </div>
      </div>
    </Popup>
    <Popup v-model="errorShow" class="border-message-popup">
      <div class="error-popup">
        <div class="title">审核失败</div>
        <div class="message">
          {{ errorMessage }}
        </div>
        <div class="btn-common block" @click="errorShow = false">我知道了</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup, Icon, Step, Steps } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import Upload from '@/components/upload/index.vue'
import { skipApp } from '@/utils/goApp'
const action = 'shareActivitySubmit'
import { expressService } from '@/api'
import copyText from '@/utils/clipboard'

export default {
  name: action,
  components: { Upload, Icon, Popup, Step, Steps },
  data() {
    return {
      appUser,
      title: '查看进度和奖励',
      dataDetail: null,
      examineData: {},
      detail: {},
      addressDetail: {},
      show: false,
      errorShow: false,
      isErrorIcon: false,
      errorMessage: '',
      errorShowNum: 0,
      isFixedBottom: false,
      wlList: [],
      gzhShow: false
    }
  },
  mixins: [Body],
  created() {
    this.activityId = this.$route.query.activityId
    // // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  activated() {},
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mounted() {
    console.log(this.$refs.activityMain.clientHeight, document.body.clientHeight)
    this.setIsFixedBottom()
  },

  methods: {
    setIsFixedBottom() {
      this.$nextTick(() => {
        this.isFixedBottom = document.body.clientHeight > this.$refs.activityMain.clientHeight + 58
      })
    },
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
      })
    },
    //进度
    //详情
    getData() {
      activityService
        .shareActivityDetail({
          activityId: this.activityId
        })
        .then(res => {
          console.log(res, 'res')
          this.dataDetail = res.activityInfo
          this.examineData = res.examineData
          if (this.examineData) {
            this.detail = this.dataDetail.rewardGoodsList.find(item => item.goodsId == this.examineData.rewardGoodsId)
            this.addressDetail = this.examineData.addressInfo && JSON.parse(this.examineData.addressInfo)
            this.errorMessage = this.examineData.failReason || ''
            if (this.examineData.orderSn) {
              console.log('object')
              expressService
                .expressInfo({
                  orderSn: this.examineData.orderSn,
                  expressNo: this.examineData.expressSn,
                  comCode: this.examineData.expressCompanyCode
                })
                .then(res => {
                  this.wlList = res.data
                  console.log(res, this.wlList, 'eeee')
                  this.setIsFixedBottom()
                })
            }

            this.$nextTick(() => {
              if (this.$refs.errorMessage) {
                let width = this.$refs.errorMessage.clientWidth
                this.errorShowNum = width / 14 - 3
                this.isErrorIcon = width / 14 - 3 < this.errorMessage.length
              }
              this.setIsFixedBottom()
            })
          } else {
            this.$router.replace({
              name: 'shareActivity'
            })
          }
        })
        .catch(err => {})
    },
    afresh() {
      this.$router.replace({
        name: 'shareActivitySubmit',
        query: { activityId: this.activityId, rewardGoodsId: this.examineData.rewardGoodsId }
      })
    },
    goApp() {
      skipApp({ ...this.detail, albumGoodsId: this.detail.goodsId }, this)
    },

    goActivity() {
      location.href = this.dataDetail.applyActivityUrl
    },
    copy(code, $event) {
      const text = `${code || '-'}`
      copyText(text, $event)
    },
    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    },
    setAddress() {
      if (this.examineData.examineStatus !== 0) return
      this.$router.push({
        name: 'addressListNew',
        query: {
          type: 'uploadActivity',
          activityId: this.activityId,
          id: this.examineData.id,
          addressId: this.addressDetail.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.minheight100 {
  background: #f5f5f5;
  background: url(./images/bg.png) no-repeat;
  background-size: 100% 100%;
}
.share-activity-submit {
  padding: 16px;
}

.content-border-top {
  margin-top: -34px;
  .line-border {
    height: 34px;
    border-radius: 34px 34px 0 0;
    margin: 0 -10px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.4);
  }
}
.share-content {
  background: #fff;
  padding-top: 30px;
  border-radius: 24px 24px 0 0;
  margin-top: -24px;
}
.apply-status {
  text-align: center;
  padding: 40px 0;
  .status {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: inline-block;
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
  .status1 {
    color: #00b25a;
  }
  .status2 {
    color: #00b259;
  }
  .status3 {
    color: #e33700;
  }
  .commit {
    color: #999;
  }
  .status-btn {
    margin: 24px auto 0;
    width: 200px;
  }
}
.fixed-bottom {
  background: transparent;
  text-align: center;
  color: #00b25a;
}
.activity-home {
  width: 48px;
  height: 60px;
  position: fixed;
  bottom: 100px;
  right: 0;
  background: url(./images/activity_home_bg.png) no-repeat;
  background-size: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  padding: 14px 8px 14px 12px;
}
.service-popup {
  padding: 39px;
  padding-bottom: 84px;
  text-align: center;
  background: linear-gradient(180deg, rgba(0, 102, 102, 0.2) 0%, rgba(0, 102, 102, 0) 100%), #fff;
  position: relative;
  .close-icon {
    position: absolute;
    top: 18px;
    right: 15px;
    opacity: 0.9;
    font-size: 16px;
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .tip {
    color: #999;
    margin-bottom: 20px;
  }
  .img {
    border-radius: 4px;
    border: 1px solid #000;
    width: 200px;
    height: 200px;
    margin: 0 auto;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.error-popup {
  padding: 32px;
  min-width: 280px;
  max-width: 100%;
  .title {
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .message {
    color: #999;
    margin-bottom: 24px;
  }
  .btn-common {
    padding: 12px 15px;
  }
}
.adviser-img {
  width: 100%;
  background: #fff;
  text-align: center;
  padding: 12px;
  margin-top: -16px;
  border-radius: 0 0 8px 8px;
  .border {
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
  }
  img {
    width: 200px;
    height: 200px;
    margin: 32px 0;
  }
  .commit {
    color: #999;
    margin-top: -16px;
  }
}
.express-info_title {
  text-align: left;
  padding: 0.24rem 0;
  border-bottom: 1px solid #eeeeee;
}
.express-info {
  text-align: left;
}
.address-box {
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  .address-main {
    border-radius: 0;
    margin: 0;
  }
  .express-detail {
    border-top: 1px solid #f5f5f5;
    display: flex;
    justify-content: space-between;
    padding: 19px 0 9px;
    margin: 0 12px;
    .express-box {
      display: flex;
      align-items: center;
      .img {
        padding: 4px;
        background: #eaefef;
        border-radius: 50%;
        margin-right: 8px;
      }
      img {
        width: 14px;
        height: 14px;
        display: block;
      }
    }
  }
}
.gz-gzh {
  border-radius: 8px;
  border: 1px solid #fff;
  background: linear-gradient(291deg, rgba(0, 102, 102, 0.2) -18.21%, rgba(0, 102, 102, 0.01) 90.23%), #fff;
  padding: 20px 16px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .gz-content {
    margin-right: 12px;
    flex: 1;
    .gz-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 12px;
      span {
        color: #00b25a;
      }
    }
    .gz-commit {
      color: rgba($color: #000000, $alpha: 0.5);
    }
  }
  .gz-btn {
    width: 66px;
    height: 28px;
    line-height: 28px;
    padding: 0;
    border-radius: 28px;
  }
}
</style>
